import type { MemberAccessRule } from './types.js';
import { C_MEMBER_ACCESS_RULES } from './c.js';

export const CPP_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  ...C_MEMBER_ACCESS_RULES,
  { parentType: 'qualified_identifier', objectField: 'scope', propertyField: 'name', tagKind: 'member' },
];
